import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { FeedbackModalComponent } from '../feedback-modal/feedback-modal.component';

@Component({
  selector: 'app-customer-feedback',
  standalone: true,
  imports: [CommonModule, IonicModule, FeedbackModalComponent],
  template: `<ion-row>
    <ion-col>
      <p class="text-center">
        <strong>Hvordan var opplevelsen din med strømanalysen?</strong>
      </p>
      <div class="flex justify-center gap-4">
        <ion-button (click)="giveRating(true)" class="w-full">
          <ion-icon name="thumbs-up-outline" class="mr-2"></ion-icon>
          Bra
        </ion-button>
        <ion-button (click)="giveRating(false)" class="w-full">
          <ion-icon name="thumbs-down-outline" class="mr-2"></ion-icon>
          Ikke helt bra
        </ion-button>
      </div>
      <ion-modal
        [isOpen]="openModal"
        (didDismiss)="openModal = false"
        class="feedback-modal-content"
      >
        <ng-template>
          <ion-content>
            <app-feedback-modal [rating]="rating"></app-feedback-modal>
          </ion-content>
        </ng-template>
      </ion-modal>
    </ion-col>
  </ion-row>`,
  styleUrl: './customer-feedback.component.scss'
})
export class CustomerFeedbackComponent {
  rating: boolean;
  openModal = false;

  constructor() {}

  giveRating(rating: boolean) {
    this.rating = rating;
    this.openModal = true;
  }
}
